import { render, staticRenderFns } from "./vat-invoice.vue?vue&type=template&id=a5d5f9e6"
import script from "./vat-invoice.vue?vue&type=script&lang=ts"
export * from "./vat-invoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInput: require('/vercel/path0/components/ui/input.vue').default,ChefBookCompanyAddress: require('/vercel/path0/components/chef/book/company-address.vue').default})
